import React, { useState } from 'react';

import { useIntl } from 'react-intl';

import { EditorInput } from 'components/Editors/components/EditorInput';
import { JRCButton } from 'components/JRCButton/JRCButton';

import { JRCModalLayout } from 'components/JRCModal/JRCModalLayout';
import { JRCModalContent } from 'components/JRCModal/JRCModalContent';
import { JRCModalFooter } from 'components/JRCModal/JRCModal.styles';

export const ModalColumnLabelize = ({
    title,
    initialValue,
    onChange,
    onCloseHandler,
}: {
    title: string;
    initialValue?: string;
    onChange: (label: string | undefined) => void;
    onCloseHandler: () => void;
}) => {
    const intl = useIntl();
    const [label, setLabel] = useState<string | undefined>(undefined);

    return (
        <JRCModalLayout enableClickAwayCloseModal={true} open={true} closeHandler={onCloseHandler}>
            <JRCModalContent overflow={'scroll'} title={title} onClickIconClose={onCloseHandler}>
                <EditorInput
                    label={intl.formatMessage({ id: 'WIDGET_Input_Label' })}
                    initialValue={initialValue ?? label}
                    onChange={(label) => setLabel(label)}
                />
            </JRCModalContent>
            <JRCModalFooter>
                <JRCButton
                    label={intl.formatMessage({ id: 'GLOBAL_Confirm' })}
                    variant={'contained'}
                    onClick={() => {
                        onChange(label);
                        onCloseHandler();
                    }}
                />
            </JRCModalFooter>
        </JRCModalLayout>
    );
};
